var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-btn',{staticClass:"mt-14",attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"#263B4F"},on:{"click":_vm.downloadCalc}},[_c('span',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("Download Calculation")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }